// extracted by mini-css-extract-plugin
export default {"COLOR":"button-style_COLOR__bYdN+","primaryColorBg":"button-style_primaryColorBg__nNFoN","secondaryBtnColorBg":"button-style_secondaryBtnColorBg__YsQze"};